export default __webpack_public_path__ + "static/media/list_main_12_1.1e1e743d.png";